export default __webpack_public_path__ + "static/media/25.67eab5e1.PNG";